export default {
  interactiveComponent: '互动元件',
  endPane: {
    title: '结束页',
    background: {
      label: '设置背景',
      opaque: '不透明度',
    },
  },
  jump: {
    title: '设置跳转',
    unit: '次',
    endToShop: '试玩结束自动跳转应用商店',
    clickToShap: '指定点击次数跳转应用商店',
  },
  event: {
    label: '事件',
    hot: '热区',
    eventHand: '手势',
    placeholder: '请选择',
    click: '点击',
    swipe: '滑动',
    longPress: '长按',
  },
  ivSetting: {
    interactive: '互动',
    auto: '自动',
    longPress: '长按',
    method: '循环方式',
    title: '互动设置',
    label: '互动类型',
  },
  ivUnit: {
    freeze: '互动定格',
    loop: '互动循环',
    longPress: '长按播放',
    play: '自动跳转',
  },
  unitTip: {
    freeze: '暂停播放，直到用户点击',
    loop: '循环播放，直到用户点击',
    longPress: '长按播放，抬手暂停',
  },
  loop: {
    single: '单向循环',
    both: '双向循环',
  },
  sync: {
    title: '编辑同步',
    content:
      '检测到其他节点包含相同视频，是否将其他节点的编辑同步到当前节点？选择后不可修改',
    sync: '同步',
    noSync: '不同步',
  },
  guideTip: {
    maskTip: '通过创建节点，完成互动视频脚本编辑。',
    knowMsg: '知道了',
    firstStep: '快捷键「Enter」新建同级节点，「Tab」新建子节点',
    secondStep: '上传视频到项目中',
    thirdStep: '拖拽视频添加到节点中',
    fourthStep: '节点内可添加互动元件，以控制视频播放。',
    fifthStep: '节点间默认为互动跳转，点击可设置跳转方式',
  },
  validateTip: {
    banRemoveVideo: '不可删除',
    banRemoveHotArea: '节点间的互动设置不可删除',
  },
  segment: {
    hand: '手势区域',
    videoNode: '视频节点',
  },
  sceneErrorType: {
    noVideo: '未添加视频，无法插入资源',
    noSpace: '当前没有位置放置互动元件',
    insertFail: '添加失败',
    segmentNotFound: '找不到目标元件',
    createNodeFail: '元件对应节点创建失败',
  },
  brain: {
    rule: {
      endding: '当前分支已有结束页',
    },
    node: {
      enddingname: '结束页',
      videoname: '视频节点',
      menu: {
        copy: '复制节点',
        paste: '粘贴节点',
        delete: '删除节点',
      },
      unitType: {
        rule: {
          tipsa: '当前存在多个热区，不允许切换为自动跳转',
          tipsb: '未找到脑图数据，无法切换',
        },
      },
      emptyNode: {
        title: '无视频信息',
      },
      video: {
        rule: {
          tipsa: '结束页不允许添加视频',
          tipsb: '未添加视频，无法插入资源',
          tipsc: '自动跳转无法添加节点',
        },
      },
      editname: {
        title: '节点名称',
      },
      sync: {
        tips: '和包含相同视频的节点编辑同步',
      },
    },
    board: {
      title: '故事板',
      action: {
        upload: {
          title: '上传视频',
        },
        localUpload: {
          title: '从本地上传',
        },
        lib: {
          title: '从库里选择',
        },
      },
      exitFullScreen: '退出全屏',
    },
    videoList: {
      title: '项目视频',
      remove: {
        dialog: {
          title: '删除已添加的视频',
          content: '删除已添加到节点中的视频，将会一并删除节点的所有内容。',
        },
      },
    },
  },
  resource: {
    uploade: {
      rule: {
        video: {
          tips: '请在视频面板上传视频资源',
        },
      },
    },
  },
}
